import emitter from "@/utils/eventBus";
import axios from "axios";
import { ref, nextTick, onMounted } from "vue";
import BatteryIcon from "@/components/icons/BatteryIcon.vue";
import DistributorIcon from "@/components/icons/DistributorIcon.vue";
import HomeIcon from "@/components/icons/HomeIcon.vue";
import SolarIcon from "@/components/icons/SolarIcon.vue";
import Loader from "@/components/Loader.vue";

import { fetchGraphData } from "../DashboardUtils/GraphData";
import { fetchDeviceStats } from "./statsData";
import { getDeviceStatus } from "@/utils/eventBus";

const chatContainer = ref(null); // Declare the ref
import moment from "moment";
import SimpleBarChart from "../SimpleBarChart.vue";
import SmartTipsCustomer from '@/components/SmartTipsCustomer.vue';

import { StatsCard, AnimatedNumber } from "@/components";
import {
  customerByPath,
  baseUrl,
  customerByWallet,
  sellerByWallet,
  sellerByAgent,
  sellers,
} from "../../../utils/userInfo";
import Tabs from "@/components/Tabs.vue";
import SimpleLineChart from "../SimpleLineChart.vue";
export default {
  components: {
    StatsCard,
    AnimatedNumber,
    SimpleBarChart,
    SimpleLineChart,
    BatteryIcon,
    SolarIcon,
    DistributorIcon,
    HomeIcon,
    Tabs,
    Loader,
    SmartTipsCustomer,
  },
  async mounted() {
    this.sellerOptions = sellers;
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener("click", this.handleOrderingClickOutside);

    this.customer = customerByPath[this.$route.path];
    if (!this.customer) return;
    const deviceKey = this.customer.token.split("|")[0];

    const initialStatus = getDeviceStatus(deviceKey);
    if (typeof initialStatus === "boolean") {
      this.statusText = initialStatus ? "Online" : "Offline";
      this.statusIcon = initialStatus
        ? "/img/green-dot.png"
        : "/img/red-dot.png";
    }

    emitter.off("device-status");
    emitter.on("device-status", ({ device, isOnline }) => {
      if (device === this.customer.token.split("|")[0]) {
        this.statusText = isOnline ? "Online" : "Offline";
        this.statusIcon = isOnline ? "/img/green-dot.png" : "/img/red-dot.png";
      }
    });
    setInterval(() => {
      this.checkTimeAndRefresh();
      this.fetchFETPrice();
    }, 60000); // každých 60 sekúnd
    this.fetchData();

    //this.fetchDeviceStatus();
    this.getEnergyTokens();
    this.chatContainer = this.$refs.chatContainer;
    this.onMounted();
    this.updateData();
    this.fetchFETPrice();
    this.refreshCharts();
    this.updateSmartTips();
    this.getPreferredSeller();

    emitter.off("update-values");
    emitter.on("update-values", ({ wsMessage, device }) => {
      if (!this.customer) return;
      if (
        this.$route.path === this.customer.path &&
        (device === this.customer.token.split("|")[0] ||
          (this.customer.solar &&
            device === this.customer.solar.split("|")[0]) ||
          (this.customer.battery &&
            device === this.customer.battery.split("|")[0]))
      ) {
        const phases = ["L1", "L2", "L3"];
        const avgPhases = (obj) => {
          let sum = 0;
          let count = 0;

          phases.forEach((phase) => {
            const value = obj?.[phase];
            if (typeof value === "number") {
              sum += value;
              count++;
            }
          });

          return count > 0 ? sum / count : 0;
        };

        const sumPhases = (obj) => {
          let sum = 0;

          phases.forEach((phase) => {
            const value = obj?.[phase];
            if (typeof value === "number") {
              sum += value;
            }
          });

          return sum > 0 ? sum : 0;
        };

        if (
          this.customer.solar &&
          device === this.customer.solar.split("|")[0]
        ) {
          this.solarpower = Number(sumPhases(wsMessage.data.P));
          this.solarvoltage = Number(avgPhases(wsMessage.data.U));
          this.solarcurrent = Number(sumPhases(wsMessage.data.I));
          this.solarenergy = Number(sumPhases(wsMessage.data.E_I));
          this.solarenergy =
            this.energy < 1000 ? this.energy : this.energy / 1000; //Wh to kWh
        } else if (
          this.customer.battery &&
          device === this.customer.battery.split("|")[0]
        ) {
          this.batterypower = Number(sumPhases(wsMessage.data.P));
          if (this.batterypower > 0) this.batterydirection = "forward";
          else if (this.batterypower < 0) this.batterydirection = "backward";
          else this.batterydirection = "stop";
          this.batteryvoltage = Number(avgPhases(wsMessage.data.U));
          this.batterycurrent = Number(sumPhases(wsMessage.data.I));
          this.batteryenergy = Number(sumPhases(wsMessage.data.E_I));
          this.batteryenergy =
            this.energy < 1000 ? this.energy : this.energy / 1000; //Wh to kWh
        } else {
          this.voltage = Number(avgPhases(wsMessage.data.U));
          this.current = Number(sumPhases(wsMessage.data.I));
          this.power = Number(sumPhases(wsMessage.data.P));
          this.energy = Number(sumPhases(wsMessage.data.E_I));
          this.energy = this.energy < 1000 ? this.energy : this.energy / 1000; //Wh to kWh
          if (!this.customer.solar) {
            this.solarpower = 0;
          }
          if (!this.customer.battery) {
            this.batterypower = 0;
            this.batterydirection = "stop";
          }
          if (this.power > 0) this.griddirection = "backward";
          else if (this.power < 0) this.griddirection = "forward";
          else this.griddirection = "stop";
        }
      }
    });
    this.initEnergyFlowAnimation(); // zapni animáciu

    // Reload 15/30/45/00
    const scheduleNextTransactionUpdate = () => {
      const now = new Date();
      const minutes = now.getMinutes();
      const nextUpdateIn =
        (15 - (minutes % 15)) * 60 * 1000 - now.getSeconds() * 1000;

      setTimeout(async () => {
        if (this.customer && this.$route.path === this.customer?.path) {
          await this.getBalance();
          await this.getTransactions();
          this.calculateHistoricalBalances();
        }
        scheduleNextTransactionUpdate();
      }, nextUpdateIn);
    };

    scheduleNextTransactionUpdate();
  },
  watch: {
    "$route.path": {
      handler: async function () {
        this.customer = customerByPath[this.$route.path];
        if (!this.customer) return;
        this.activePanel = "Grid";
        this.graphTimeRange = "Day";
        this.showFinancial = false;
        this.tabsKey++;
        //this.fetchDeviceStatus();
        this.updateData();
        this.refreshCharts();
        this.fetchData();
        this.onMounted();
        this.smartTipsText = "Smart Tips provided by AI are currently loading...";
        this.updateSmartTips();
        this.getPreferredSeller();
        

        this.getEnergyTokens();

        this.deviceKey = this.customer.token.split("|")[0];
        const deviceStatus = getDeviceStatus(this.deviceKey);
        this.statusText = deviceStatus ? "Online" : "Offline";
        this.statusIcon = deviceStatus
          ? "/img/green-dot.png"
          : "/img/red-dot.png";
      },
      activePanel() {
        this.refreshCharts();
      },
    },
  },

  computed: {
    orderingDaysInMonth() {
      const days = [];
      const year = this.orderingCurrentMonth.getFullYear();
      const month = this.orderingCurrentMonth.getMonth();
      const firstDay = new Date(year, month, 1);
      const lastDay = new Date(year, month + 1, 0);
      for (let d = new Date(firstDay); d <= lastDay; d.setDate(d.getDate() + 1)) {
        days.push({ date: new Date(d) });
      }
      return days;
    },
    daysInMonth() {
      const days = [];
      const year = this.currentMonth.getFullYear();
      const month = this.currentMonth.getMonth();
      const first = new Date(year, month, 1);
      const last = new Date(year, month + 1, 0);
      for (let d = new Date(first); d <= last; d.setDate(d.getDate() + 1)) {
        days.push({ date: new Date(d) });
      }
      return days;
    },
    pvConsumedPct() {
      return (this.pvConsumed / this.pvGenerated) * 100;
    },
    pvFedToGridPct() {
      return (this.pvFedToGrid / this.pvGenerated) * 100;
    },
    pvContributionPct() {
      return (this.pvConsumed / this.totalConsumed) * 100;
    },
    gridContributionPct() {
      return (this.gridConsumed / this.totalConsumed) * 100;
    },
    batteryContributionPct() {
      return (this.batteryConsumed / this.totalConsumed) * 100;
    },
    pvConsumedPctFinancial() {
      return (this.pvConsumedFinancial / this.pvGeneratedFinancial) * 100;
    },
    pvFedToGridPctFinancial() {
      return (this.pvFedToGridFinancial / this.pvGeneratedFinancial) * 100;
    },
    pvContributionPctFinancial() {
      return (this.pvConsumedFinancial / this.totalConsumedFinancial) * 100;
    },
    gridContributionPctFinancial() {
      return (this.gridConsumedFinancial / this.totalConsumedFinancial) * 100;
    },
    batteryContributionPctFinancial() {
      return (this.batteryConsumedFinancial / this.totalConsumedFinancial) * 100;
    },
    computedTabNames() {
      this.customer = customerByPath[this.$route.path];
      if (!this.customer) return;
      const tabs = ["Grid"];
      if (this.customer.solar) tabs.push("Solar Panels");
      if (this.customer.battery) tabs.push("Battery");
      return tabs;
    },
    dateGroups() {
      if (!this.startTimestamp || this.columnCount === 0) {
        return []; // skip rendering until data is ready
      }

      const dates = [];
      let currentDate = "";
      let groupStart = 0;

      for (let i = 0; i < this.columnCount; i++) {
        const timestamp = this.startTimestamp + i * 15 * 60;
        const date = new Date(timestamp * 1000);
        const dateStr = date.toLocaleDateString("sk-SK"); // returns DD.MM.YYYY

        if (dateStr !== currentDate) {
          if (currentDate !== "") {
            dates.push({
              start: groupStart,
              span: i - groupStart,
              label: currentDate,
            });
          }
          currentDate = dateStr;
          groupStart = i;
        }
      }

      // Final group
      dates.push({
        start: groupStart,
        span: this.columnCount - groupStart,
        label: currentDate,
      });

      return dates;
    },
    summaryRow() {
      const fetAmount = Number(this.balance) / 1e18;
      const price = this.fetPriceUSD;
      const usdAmount = price ? (fetAmount * price).toFixed(2) : "-";

      return [
        {
          address: this.address,
          agAddress: this.agAddress,
          balance: this.balance?.toString?.() || "0",
          usdAmount,
          fetAmount,
        },
      ];
    },
    paginatedTransactions() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.transactionsWithBalance.slice(start, end);
    },
    totalPages() {
      return (
        Math.ceil(this.transactionsWithBalance.length / this.itemsPerPage) || 1
      );
    },
  },
  methods: {
    toTestFET(atto) {
      return (Number(atto) / 1e18).toFixed(5);
    },
    async fetchSellerPrice() {
        const agent = customerByPath[this.$route.path];
        if (!agent) return;      
        try {
        const url = `${agent.agentUrl}/rest/details`;
        const response = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ text: "", session_id: 0 }),
        });

        if (!response.ok)
          return;

        const data = await response.json();
        if (data) {
          this.sellerMarketPrice = this.toTestFET(parseFloat(data.currentPrice));
        }
      } catch (error) {
      }
    },

    async getPreferredSeller() {
      const agent = customerByPath[this.$route.path];
      if (!agent) return;
      const prefSellerResponse = await axios.post(`${agent.agentUrl}/rest/resources`, {
        text: "",
        session_id: 0
      });
          
          const prefSeller = prefSellerResponse.data.preferred_seller_name;
          if (prefSeller == 0) {
            this.preferredSeller = "automatic"
            return;
          }
          this.preferredSeller = prefSeller;
          this.fetchSellerPrice();
    },
    async onPreferredSellerChange() {
      const agent = customerByPath[this.$route.path];
      if (!agent) return;
      let prefSeller;
      if (this.preferredSeller === "automatic") {
        prefSeller = 0;
      }
      else {
        prefSeller = this.preferredSeller;
      }

      await axios.post(`${agent.agentUrl}/rest/setPreferredSeller`, {
        preferred_seller_name: prefSeller
      });
      this.fetchSellerPrice();

    },

    async updateSmartTips() {
      const oneDay = 24 * 3600;
        let now = Math.floor(Date.now() / 1000);
        let from;
        let granularity;
        let labelFormat;
      
        switch (this.graphTimeRange) {
          case "Custom":
            from = Math.floor(new Date(customRangeStart).setHours(0, 0, 0, 0) / 1000);
            const end = Math.floor(new Date(customRangeEnd).setHours(0, 0, 0, 0) / 1000);
            const duration = end - from;
            if (duration <= 0) {
              return;
            }
            else if (duration <= oneDay) {
              granularity = "block";
              labelFormat = "DD.MM HH:mm";
            } else if (duration <= 30 * oneDay) {
              granularity = "day";
              labelFormat = "DD MMM";
            } else {
              granularity = "month";
              labelFormat = "MMM YYYY";
            }
            now = end;
            break;
          case "Day":
            from = Math.floor(moment().startOf('day').valueOf() / 1000);
            granularity = "block"; 
            labelFormat = "HH:00";
            break;
          case "Week":
            from = moment().subtract(7, "days").unix();
            granularity = "day";
            labelFormat = "DD MMM";
            break;
          case "Month":
            from = moment().subtract(30, "days").unix();
            granularity = "day";
            labelFormat = "DD MMM";
            break;
          case "Year":
          default:
            from = moment().startOf("year").unix();
            granularity = "month";
            labelFormat = "MMM";
            break;
        }
      
        const agent = customerByPath[this.$route.path];
        if (!agent) return;
      
        //GET SMART TIPS FROM LLM
        try {
          let analysisType = "grid";
          if (this.activePanel === "Solar Panels") analysisType = "solar";
          if (this.activePanel === "Battery") analysisType = "battery";
      
          const tipsRes = await axios.post(`${agent.agentUrl}/rest/smartTips`, {
            startTimestamp: from,
            endTimestamp: now,
            granularity,
            analysisType
          });
      
          this.smartTipsText = tipsRes.data.text;
        } catch (err) {}
    },

    getEnergyTooltip(cell, rowIndex, colIndex) {
      if (cell === 0) return "";

      const source = this.sources?.[rowIndex] || "Unknown";
      const time = this.formatOrderingPlanTime(colIndex);
      const consumption = this.consumptionMatrix?.[rowIndex]?.[colIndex] ?? 0;
      let label = "";

      if (cell === 1) {
        label = "Reserved energy";
      } else if (cell === 2) {
        label = "Sold energy";
      } else if (cell === 3) {
        label = "Paid energy and ACK from seller";
      }

      return `${label} | Source: ${source} | Consumption: ${consumption.toFixed(
        2
      )} kWh`;
    },

    async fetchFETPrice() {
      try {
        const response = await fetch(
          "https://www.okx.com/api/v5/market/ticker?instId=FET-EUR"
        );
        const data = await response.json();
        if (data?.data?.[0]?.last) {
          this.fetPriceUSD = parseFloat(data.data[0].last);
        }
      } catch (error) {}
    },
    convertFETToUSD(fetValue) {
      if (!this.fetPriceUSD || isNaN(fetValue)) return "0.0000";
      return (fetValue * this.fetPriceUSD).toFixed(4);
    },
    convertFETToEUR(fetValue) {
      if (!this.fetPriceUSD || isNaN(fetValue)) return "0.0000";
      return fetValue * this.fetPriceUSD;
    },

    toTestFET(value) {
      return (Number(value) / 1e18).toFixed(2);
    },

    toTestFET(value) {
      return (Number(value) / 1e18).toFixed(2);
    },

    toggleFinancial() {
      this.showFinancial = !this.showFinancial;
      this.refreshCharts();
    },
    async refreshCharts() {
      this.loadingGraphData=true; //begin of loading
      if (this.fetPriceUSD == 0) {
        await this.fetchFETPrice();
      }
      const [chartDataFinancial, chartData] = await Promise.all([
        fetchGraphData(
          this.customer,
          this.chartDataFinancial,
          this.graphTimeRange,
          this.customRangeStart,
          this.customRangeEnd,
          true,
          this.energyToPriceRate,
          this.$route.path,
          this.fetPriceUSD,
        ),
        fetchGraphData(
          this.customer,
          this.chartData,
          this.graphTimeRange,
          this.customRangeStart,
          this.customRangeEnd,
          false,
          this.energyToPriceRate,
          this.$route.path,
          this.fetPriceUSD,
        )
      ]);
      this.chartData = chartData;
      this.chartDataFinancial = chartDataFinancial;
      const datasetsFinancial = this.chartDataFinancial.datasets || [];
      // Find datasets by label (so the order in chartData doesn't matter)
      const gridDatasetFinancial = datasetsFinancial.find(ds => ds.label.includes("Grid"));
      const solarDatasetFinancial = datasetsFinancial.find(ds => ds.label.includes("Solar"));
      const batteryDatasetFinancial = datasetsFinancial.find(ds => ds.label.includes("Battery"));

      // Compute sums safely (if dataset not found, default to 0)
      this.gridConsumedFinancial = gridDatasetFinancial
        ? gridDatasetFinancial.data.reduce((sum, val) => sum + val, 0)
        : 0;
      this.pvConsumedFinancial = solarDatasetFinancial
        ? solarDatasetFinancial.data.reduce((sum, val) => sum + val, 0)
        : 0;
      this.batteryConsumedFinancial = batteryDatasetFinancial
        ? batteryDatasetFinancial.data.reduce((sum, val) => sum + val, 0)
        : 0;
      this.pvFedToGridFinancial=0;
      this.pvGeneratedFinancial=this.pvConsumedFinancial+this.pvFedToGrid;
      this.totalConsumedFinancial=this.gridConsumedFinancial+this.pvConsumedFinancial+this.batteryConsumedFinancial;

      const datasets = this.chartData.datasets || [];

      // Find datasets by label (so the order in chartData doesn't matter)
      const gridDataset = datasets.find(ds => ds.label.includes("Grid"));
      const solarDataset = datasets.find(ds => ds.label.includes("Solar"));
      const batteryDataset = datasets.find(ds => ds.label.includes("Battery"));

      // Compute sums safely (if dataset not found, default to 0)
      this.gridConsumed = gridDataset
        ? gridDataset.data.reduce((sum, val) => sum + val, 0)
        : 0;

      this.pvConsumed = solarDataset
        ? solarDataset.data.reduce((sum, val) => sum + val, 0)
        : 0;

      this.batteryConsumed = batteryDataset
        ? batteryDataset.data.reduce((sum, val) => sum + val, 0)
        : 0;

      this.pvFedToGrid=0;
      this.pvGenerated=this.pvConsumed+this.pvFedToGrid;
      
      this.totalConsumed=this.gridConsumed+this.pvConsumed+this.batteryConsumed;
      this.loadingGraphData=false; //end of loading
    },
    setActivePanel(panel) {
      this.activePanel = panel; // Update activePanel when the tab changes
      //this.refreshCharts();
      this.updateSmartTips();
    },

    //FUNKCIE PRE RANGE PRI ENERGY ORDERING PLANE
    handleOrderingClickOutside(event) {
      if (
      this.showOrderingCalendar &&
      !this.$refs.orderingCalendarPopup?.contains(event.target) &&
      !this.$refs.orderingTabsContainer?.contains(event.target)
      ) {
        this.showOrderingCalendar = false;
      }
    },

    toggleOrderingCalendar() {
      this.showOrderingCalendar = !this.showOrderingCalendar;

      this.$nextTick(() => {
        const button = this.$refs.orderingRangeButton?.$el || this.$refs.orderingRangeButton;
        const container = this.$refs.orderingTabsContainer;

        if (button && container) {
          const btnRect = button.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();

          this.orderingCalendarPosition = {
            top: `${btnRect.bottom - containerRect.top}px`,
            left: `${btnRect.left - containerRect.left}px`,
          };
        }
      });
    },

    prevOrderingMonth() {
      this.orderingCurrentMonth = new Date(
      this.orderingCurrentMonth.getFullYear(),
      this.orderingCurrentMonth.getMonth() - 1,
      1
      );
    },
    nextOrderingMonth() {
      this.orderingCurrentMonth = new Date(
      this.orderingCurrentMonth.getFullYear(),
      this.orderingCurrentMonth.getMonth() + 1,
      1
      );
    },
    isOrderingSelected(date) {
        if (!this.orderingSelectedDate) return false;

        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const dateStr = `${yyyy}-${mm}-${dd}`;

        return this.orderingSelectedDate === dateStr;
      },
    isOrderingToday(date) {
      const today = new Date();
      return date.toDateString() === today.toDateString();
      },
    selectOrderingDay(date) {
      this.orderingSelectedDate = new Date(date);
      this.showOrderingCalendar = false;

      // Nastav timestamp použitý vo fetchData
      const selectedTimeParts = this.orderingSelectedTime.split(":");
      const hours = parseInt(selectedTimeParts[0]);
      const minutes = parseInt(selectedTimeParts[1]);
      this.orderingSelectedTime = `${String(hours).padStart(2, '0')}:00`;

      this.orderingSelectedDate.setHours(hours);
      this.orderingSelectedDate.setMinutes(0);
      this.orderingSelectedDate.setSeconds(0);
      this.orderingSelectedDate.setMilliseconds(0);

      const unix = Math.floor(this.orderingSelectedDate.getTime() / 1000);
      this.overrideOrderingStartUnix = unix;

      this.fetchData();
    },

    adjustOrderingTime(hours) {
        if (!this.orderingSelectedDate || !this.orderingSelectedTime) return;

        const [h, m] = this.orderingSelectedTime.split(":").map(Number);
        const date = new Date(this.orderingSelectedDate);

        // Nastav aktuálny čas (s minútami na 0)
        date.setHours(h);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);

        // Pridaj alebo odober hodiny
        date.setHours(date.getHours() + hours);

        // Aktualizuj orderingSelectedDate (YYYY-MM-DD formát)
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        this.orderingSelectedDate = `${yyyy}-${mm}-${dd}`;

        // Aktualizuj orderingSelectedTime (HH:00 formát)
        const updatedHours = String(date.getHours()).padStart(2, '0');
        this.orderingSelectedTime = `${updatedHours}:00`;

        // Prepočet unix timestampu
        this.overrideOrderingStartUnix = Math.floor(date.getTime() / 1000);

        // Fetchni nové dáta
        this.refreshOrderingData();
      },

    refreshOrderingData() {
      if (!this.orderingSelectedDate || !this.orderingSelectedTime) return;
      const [h, m] = this.orderingSelectedTime.split(":").map(Number);
      const date = new Date(this.orderingSelectedDate);
      date.setHours(h);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
      this.overrideOrderingStartUnix = Math.floor(date.getTime() / 1000);
      this.fetchData();
    },

    // FUNKCIE PRE RANGE PRI GRAFOCH
    activateCustomRange(event) {
      this.graphTimeRange = 'Custom';
      this.selectedStart = null;
      this.selectedEnd = null;
      this.showCustomCalendar = true;

      this.$nextTick(() => {
        const buttonEl = this.$refs.customButton?.$el || this.$refs.customButton;
        const container = this.$refs.tabsContainer;

        if (buttonEl && container) {
          const btnRect = buttonEl.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();

          // Pozícia voči .tab-buttons
          const top = btnRect.bottom - containerRect.top + 8;
          const left = btnRect.left - containerRect.left;

          this.calendarPosition.top = `${top}px`;
          this.calendarPosition.left = `${left}px`;
        }
      });
    },

    selectDay(date) {
      if (!this.selectedStart || (this.selectedStart && this.selectedEnd)) {
        this.selectedStart = date;
        this.selectedEnd = null;
      } else if (date >= this.selectedStart) {
        this.selectedEnd = date;
        this.finalizeRange();
      } else {
        this.selectedStart = date;
        this.selectedEnd = null;
      }
    },

    finalizeRange() {
      this.customRangeStart = new Date(this.selectedStart.setHours(0, 0, 0, 0));
      this.customRangeEnd = new Date(this.selectedEnd.setHours(23, 59, 59, 999));
      this.showCustomCalendar = false;
      this.refreshCharts();
    },

    isSelected(date) {
      return (
      (this.selectedStart && date.toDateString() === this.selectedStart.toDateString()) ||
      (this.selectedEnd && date.toDateString() === this.selectedEnd.toDateString())
      );
      },
      isInRange(date) {
      return (
      this.selectedStart &&
      this.selectedEnd &&
      date > this.selectedStart &&
      date < this.selectedEnd
      );
      },
      isToday(date) {
      const today = new Date();
      return date.toDateString() === today.toDateString();
    },

    prevMonth() {
      const prev = new Date(this.currentMonth);
      prev.setMonth(prev.getMonth() - 1);
      this.currentMonth = prev;
    },
    nextMonth() {
      const next = new Date(this.currentMonth);
      next.setMonth(next.getMonth() + 1);
      this.currentMonth = next;
    },

    handleClickOutside(e) {
      if (
        this.showCustomCalendar &&
        !this.$refs.calendarPopup.contains(e.target) &&
        !this.$refs.tabsContainer.contains(e.target)
      ) {
        this.showCustomCalendar = false;
      }
    },

    setGraphTimeRange(range) {
      this.graphTimeRange = range;

      switch (this.graphTimeRange) {
        case "Day":
          this.customRangeStart = moment().startOf("day").toDate();
          this.customRangeEnd = moment().endOf("day").toDate();
          break;
    
        case "Week":
          this.customRangeStart = moment().subtract(7, "days").startOf("day").toDate();
          this.customRangeEnd = moment().endOf("day").toDate();
          break;
    
        case "Month":
          this.customRangeStart = moment().subtract(30, "days").startOf("day").toDate();
          this.customRangeEnd = moment().endOf("day").toDate();
          break;
    
        case "Year":
        default:
          this.customRangeStart = moment().startOf("year").toDate();
          this.customRangeEnd = moment().endOf("day").toDate();
          break;
      }
      this.refreshCharts();
    },
    toggleCustomRange() {
      this.graphTimeRange = "Custom";
      this.showCustomPicker = !this.showCustomPicker;

      // ak sa zobrazuje, vymaž hodnoty
      if (this.showCustomPicker) {
        this.customRangeStart = null;
        this.customRangeEnd = null;
      }
    },
    onCustomRangeChange() {
      if (this.customRangeStart && this.customRangeEnd && this.graphTimeRange === "Custom") {
        this.refreshCharts();
      }
    },
    formatDate(date) {
      return date ? moment(date).format("DD.MM.YYYY") : "-";
    },
    checkTimeAndRefresh() {
      const currentDate = new Date();
      const minutes = currentDate.getMinutes();

      // Check if the current time is 0, 15, 30, or 45 minutes past the hour
      if ([0, 15, 30, 45].includes(minutes)) {
        this.fetchData();
      }
    },
    async fetchData() {
      const hours = 12;

      const now = new Date();
      
      let roundedDate;

      if (this.overrideOrderingStartUnix) {
        // ✅ použijeme timestamp z kalendára
        roundedDate = new Date(this.overrideOrderingStartUnix * 1000);
      } else {
        roundedDate = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          now.getHours(),
          0,
          0,
          0
        );
        roundedDate.setHours(roundedDate.getHours() - 2); // posun o 2h späť
      }

      if (!this.orderingSelectedDate) {
        this.orderingSelectedDate = new Date(roundedDate);
        const hh = String(this.orderingSelectedDate.getHours()).padStart(2, '0');
        this.orderingSelectedTime = `${hh}:00`;
      }

      const startUnixTimestamp = Math.floor(roundedDate.getTime() / 1000);
      this.overrideOrderingStartUnix = null; // reset na ďalšie použitie


      //this.customer = customerByPath[this.$route.path];
      const url = `${this.customer.agentUrl}/rest/energyorderingtable`;
      const requestData = {
        startUnixTimestamp,
        hours,
      };

      try {
        const response = await fetch(url, {
          method: "POST", // Change to POST
          headers: {
            "Content-Type": "application/json", // Ensure the content type is JSON
          },
          body: JSON.stringify(requestData), // Send data as JSON string
        });

        const data = await response.json();
        if (
          data &&
          Array.isArray(data.sources) &&
          Array.isArray(data.matrix) &&
          typeof data.startUnixTimestamp === "number"
        ) {
          //update from walletaddresses to names

          this.sources = data.sources.map((agentAddr) => {
            const seller = sellerByAgent[agentAddr];
            return seller ? seller.name : agentAddr; // fallback if no match
          });
          //this.sources = data.sources;
          this.matrix = data.matrix;
          this.consumptionMatrix = data.consumptionMatrix;
          this.startTimestamp = data.startUnixTimestamp;
          this.columnCount = data.matrix[0]?.length || 0;
          this.energyOrderingDataOK = true;
        } else {
          this.energyOrderingDataOK = false;
        }
        // Highlight the current column
        const now2 = Math.floor(Date.now() / 1000);
        const minutesSinceStart = Math.floor(
          (now2 - data.startUnixTimestamp) / 60
        );
        this.currentColumnIndex = Math.floor(minutesSinceStart / 15);
        //console.log("Column index:"+this.currentColumnIndex);
      } catch (error) {
        //    console.error('Error fetching energy data:', error);
        this.energyOrderingDataOK = false;
      }
    },
    formatOrderingPlanTime(index) {
      const minutesOffset = index * 15;
      const ts = (this.startTimestamp + minutesOffset * 60) * 1000;
      const date = new Date(ts);
      const hours = date.getHours();
      return date.getMinutes() === 0 ? hours : "";
    },
    shouldShowHourLabel(index) {
      return index % 4 === 0;
    },
    getColumnClass(index) {
      const classes = [];

      if (index % 4 === 0) classes.push("hour-border");
      else classes.push("quarter-border");

      if (index === this.columnCount - 1) classes.push("last-column-border");

      // Add highlight if this is the current 15-min timeframe
      if (index === this.currentColumnIndex) classes.push("current-time");

      return classes.join(" ");
    },

    getCellClass(index, value) {
      const classes = [];

      if (value) {
        switch (value) {
          case 1:
            classes.push("active-cell");
            break;
          case 2:
            classes.push("active-cell-paid");
            break;
          case 3:
            classes.push("active-cell-paid-ack");
            break;
          default:
            classes.push("active-cell");
        }
      }

      if (index % 4 === 0) classes.push("hour-border");
      else classes.push("quarter-border");

      if (index === this.columnCount - 1) classes.push("last-column-border");

      // Add highlight if this is the current 15-min timeframe
      if (index === this.currentColumnIndex) classes.push("current-time");

      classes.push("row-border");

      return classes.join(" ");
    },
    initEnergyFlowAnimation() {
      this.$nextTick(() => {
        const animateDot = (dotId, pathId, delay = 0) => {
          const dot = document.getElementById(dotId);
          const path = document.getElementById(pathId);

          if (!dot || !path) {
            //console.warn(`⚠️ Missing DOM elements for ${dotId} or ${pathId}`);
            return;
          }

          const pathLength = path.getTotalLength();

          const animate = () => {
            let start = null;

            const step = (timestamp) => {
              if (!start) start = timestamp;
              const elapsed = timestamp - start;
              const duration = 3000;
              const progress = (elapsed % duration) / duration;

              // reverse only for gridPath
              const isReversed = pathId === "gridPath";
              const pathProgress = isReversed ? 1 - progress : progress;

              const point = path.getPointAtLength(pathProgress * pathLength);
              dot.setAttribute(
                "transform",
                `translate(${point.x}, ${point.y})`
              );
              requestAnimationFrame(step);
            };

            setTimeout(() => {
              requestAnimationFrame(step);
            }, delay);
          };

          animate();
        };

        animateDot("dotBattery", "batteryPath", 0);
        animateDot("dotSolar", "solarPath", 0);
        animateDot("dotGrid", "gridPath", 0);
      });
    },
    
    getTokenBasedOnRoute() {
      const path = this.$route.path;
      if (this.customer && path === this.customer.path) {
        return this.customer.token;
      }
      return "";
    },

    formatPower(value) {
      const num = Number(value);
      if (num >= 1000) {
        return `${(num / 1000).toFixed(2)} kW`;
      } else {
        return `${num.toFixed(2)} W`;
      }
    },

    async updateData() {
      if (this.$route.path === this.customer.path) {
        this.address = this.customer.walletAddress;
        this.agAddress = this.customer.agentAddress;
      } else {
        this.agAddress = "Unknown";
        this.address = "Unknown";
        this.balance = BigInt(0);
        this.rawTransactions = [];
        this.transactionsWithBalance = [];
        return;
      }

      this.currentPage = 1;
      await this.getBalance();
      await this.getTransactions();
      this.calculateHistoricalBalances();

      const { voltageStats, currentStats, powerStats } = await fetchDeviceStats(
        this.customer.token
      );

      this.voltageStats = voltageStats;
      this.currentStats = currentStats;
      this.powerStats = powerStats;
    },

    async getBalance() {
      try {
        const query = `
          query GetWalletBalance {
            balances(
              where: { address: { _eq: "${this.address}" } }
            ) {
              balance
              denom
            }
          }
        `;

        const response = await fetch(`${baseUrl}/graphql`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            query,
            operationName: "GetWalletBalance",
          }),
        });

        const result = await response.json();

        const balances = result?.data?.balances || [];
        const fetBalance = balances.find((coin) => coin.denom === "atestfet");

        this.balance = fetBalance ? BigInt(fetBalance.balance) : BigInt(0);
      } catch (error) {
        // console.error("Error fetching balance:", error);
        this.balance = BigInt(0);
      }
    },

    async getTransactions() {
      try {
        const query = `
          query GetTransactions {
            sent: transfers(
              where: {from_address: {_eq: "${this.address}"}}
              order_by: {height: desc}
              limit: 20
            ) {
              amount
              denom
              from_address
              to_address
              tx_hash
            }
          }
        `;

        //console.log(query);

        const response = await fetch(`${baseUrl}/graphql`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ query }),
        });

        const { data } = await response.json();
        const sent = data.sent || [];
        const received = data.received || [];

        // Format basic transaction object
        const formatTx = (tx, type) => ({
          txhash: tx.tx_hash,
          from: tx.from_address,
          to: tx.to_address,
          fromName: tx.from_address,
          toName: tx.to_address,
          operation: type === "sent" ? "Outgoing" : "Incoming",
          amount: tx.amount ?? "0",
          timestamp: null, // Will be filled later
          balanceAfterTx: "?",
        });

        // Combine and deduplicate
        const all = [
          ...sent.map((tx) => formatTx(tx, "sent")),
          ...received.map((tx) => formatTx(tx, "received")),
        ];

        const unique = all.filter(
          (tx, index, self) =>
            index === self.findIndex((t) => t.txhash === tx.txhash)
        );

        // Fetch timestamps in parallel
        const timestampFetches = unique.map((tx) =>
          fetch(`${baseUrl}/graphql`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              query: `
                query GetTransactionTime {
                  transactions(
                    where: {hash: {_eq: "${tx.txhash}"}}
                    limit: 1
                  ) {
                    time
                  }
                }
              `,
            }),
          })
            .then((res) => res.json())
            .then((res) => {
              const utcTime = res?.data?.transactions?.[0]?.time || null;

              if (!utcTime) return { hash: tx.txhash, time: null };
              const timezoneOffset = -1 * new Date().getTimezoneOffset(); //-120 ; I need to add 120

              const date = new Date(utcTime);
              date.setMinutes(date.getMinutes() + timezoneOffset);

              const localTime = `${date.getFullYear()}-${String(
                date.getMonth() + 1
              ).padStart(2, "0")}-${String(date.getDate()).padStart(
                2,
                "0"
              )} ${String(date.getHours()).padStart(2, "0")}:${String(
                date.getMinutes()
              ).padStart(2, "0")}:${String(date.getSeconds()).padStart(
                2,
                "0"
              )}`;

              return { hash: tx.txhash, time: localTime };
            })
            .catch(() => ({ hash: tx.txhash, time: null }))
        );

        const timestampResults = await Promise.all(timestampFetches);

        // Map hash → time
        const timestampMap = {};
        for (const { hash, time } of timestampResults) {
          timestampMap[hash] = time;
        }

        // Attach timestamps
        unique.forEach((tx) => {
          tx.timestamp = timestampMap[tx.txhash] || null;
        });

        // Sort transactions by timestamp descending
        this.rawTransactions = unique.sort(
          (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
        );

        // Pagination
        //this.paginatedTransactions = this.rawTransactions.slice(0, this.itemsPerPage);
        //this.totalPages = Math.ceil(this.rawTransactions.length / this.itemsPerPage);
        this.currentPage = 1;
      } catch (error) {
        //console.error("Error fetching transactions:", error);
        this.rawTransactions = [];
        //this.paginatedTransactions = [];
        //this.totalPages = 0;
        this.currentPage = 1;
      }
    },

    calculateHistoricalBalances() {
      const result = [];
      let runningBalance = this.balance;

      for (const tx of this.rawTransactions) {
        const from = this.getSender(tx);
        const to = this.getRecipient(tx);
        const amount = this.getAmountRaw(tx);
        const operation = this.getOperation(from, to);
        const fromName =
          customerByWallet[from]?.name ||
          sellerByWallet[from]?.name ||
          "Unknown";
        const toName =
          customerByWallet[to]?.name || sellerByWallet[to]?.name || "Unknown";

        result.push({
          txhash: tx.txhash,
          timestamp: tx.timestamp,
          from,
          to,
          operation,
          fromName,
          toName,
          amount,
          balanceAfterTx: runningBalance,
        });

        if (operation.startsWith("Incoming")) {
          runningBalance -= amount;
        } else if (operation.startsWith("Outgoing")) {
          runningBalance += amount;
        }
      }

      this.transactionsWithBalance = result;
    },

    getSender(tx) {
      return tx.from || "–";
    },

    getRecipient(tx) {
      return tx.to || "–";
    },

    getAmountRaw(tx) {
      try {
        return BigInt(tx.amount);
      } catch {
        return BigInt(0);
      }
    },

    getOperation(from, to) {
      if (from === this.address && to !== this.address) {
        return "Outgoing";
      } else if (to === this.address && from !== this.address) {
        return "Incoming";
      } else if (from === this.address && to === this.address) {
        return "Self Transfer";
      } else if (from === "–" && to !== "–") {
        return "Incoming (unknown sender)";
      } else if (to === "–" && from !== "–") {
        return "Outgoing (unknown recipient)";
      } else {
        return "Other";
      }
    },

    formatTime(iso) {
      const date = new Date(iso);
      return date.toLocaleString();
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    copyToClipboard(value, event) {
      navigator.clipboard.writeText(value).then(() => {
        const tooltip = document.createElement("div");
        tooltip.innerText = "Copied!";
        tooltip.className = "copy-tooltip";

        // Pozícia podľa kurzora
        tooltip.style.top = `${event.clientY + 10}px`;
        tooltip.style.left = `${event.clientX + 10}px`;

        document.body.appendChild(tooltip);

        // Po 1.5s tooltip zmizne
        setTimeout(() => {
          document.body.removeChild(tooltip);
        }, 1000);
      });
    },

    async getEnergyTokens() {
      try {
        const url = `${this.customer.agentUrl}/rest/balance`;
        const response = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            text: "ENERGY",
            session_id: ""
          }),
        });

        const json = await response.json();
        this.energyTokens = json.amount || 0;
      } catch (error) {}
    },

    async sendMessage() {
      const userMsg = this.newMessage.trim();
      if (!userMsg) return;

      // Add user's message with session_id
      this.messages.push({
        sender: "user",
        text: userMsg,
        session_id: this.sessionId,
      });
      this.newMessage = "";
      this.loading = true;

      await this.$nextTick();

      if (this.chatContainer) {
        //console.log("Chatcontainer found!"); //em
        this.chatContainer.scrollTop = this.chatContainer.scrollHeight;
      } //else console.log("Chatcontainer not found");
      try {
        let apiUrl = customerByPath[this.$route.path].agentUrl + "/rest/post";
        if (!apiUrl) apiUrl = `${baseUrl}/agent1/rest/post`;

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            text: userMsg,
            session_id: this.sessionId, // Add session_id to the request payload
          }),
        });

        const data = await response.json();

        // Add bot response with session_id
        this.messages.push({
          sender: "bot",
          text: data.text || "[No response text]",
          session_id: this.sessionId,
        });
        this.fetchData();
      } catch (error) {
        this.messages.push({
          sender: "bot",
          text: "[Error: Energy Agent is not responding...]",
          session_id: this.sessionId,
        });
      } finally {
        this.loading = false;

        await this.$nextTick();
        if (this.chatContainer) {
          this.chatContainer.scrollTop = this.chatContainer.scrollHeight;
        }
        this.$nextTick(() => {
          this.$refs.messageInput?.focus();
        });
      }
    },

    onMounted() {
      this.sessionId = "session_" + Math.random().toString(36).substr(2, 9);
      this.messages = [];
      if (chatContainer.value) {
        chatContainer.value.scrollTop = 0;
      }
      this.messages.push({
        sender: "bot",
        text:
          "I'm energy agent at " +
          this.customer.name +
          ". How can I assist you? ",
        session_id: this.sessionId,
      });
      if (chatContainer.value) {
        // Now it's safe to access the DOM element
        chatContainer.value.scrollTop = chatContainer.value.scrollHeight;
      }
    },
    beforeDestroy() {
      emitter.off("update-values");
      emitter.off("device-status");
      document.removeEventListener('click', this.handleClickOutside);
      document.removeEventListener("click", this.handleOrderingClickOutside);
    },
  },
  data() {
    return {
      preferredSeller: "",
      sellerMarketPrice: 0,
      sellerOptions: [],
      smartTipsText: '',

      consumptionMatrix: [],
      fetPriceUSD: 0,
      tabsKey: 0,
      activePanel: "Grid", // Initialize with the first tab name
     
      graphTimeRange: "Day",
      customRangeStart: moment().startOf("day").toDate(),
      customRangeEnd: moment().endOf("day").toDate(),
      showCustomPicker: false,
      showCustomCalendar: false,
      currentMonth: new Date(),
      selectedStart: null,
      selectedEnd: null,
      calendarPosition: { top: '0px', left: '0px' },
      dayNames: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],

      showOrderingCalendar: false,
      orderingCalendarPosition: { top: '0px', left: '0px' },
      orderingCurrentMonth: new Date(),
      orderingSelectedDate: null,
      orderingSelectedTime: '00:00',
      orderingDayNames: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
      overrideOrderingStartUnix: null,

      statusText: "Checking...",
      statusIcon: "/img/red-dot.png",
      sources: [],
      matrix: [],
      energyOrderingDataOK: true, //default is true
      columnCount: 96,
      startTimestamp: 0,
      currentColumnIndex: null,
      showFinancial: false, // prepínač medzi energiou a €
      energyToPriceRate: 0.18,
      pvGenerated:0,
      pvConsumed:0,
      pvFedToGrid:0,
      totalConsumed:0,
      gridConsumed:0,
      batteryConsumed:0,
      pvGeneratedFinancial:0,
      pvConsumedFinancial:0,
      pvFedToGridFinancial:0,
      totalConsumedFinancial:0,
      gridConsumedFinancial:0,
      batteryConsumedFinancial:0,
      loadingGraphData:true,
    
      // Add the chat-related reactive data
      newMessage: "",
      messages: [],
      loading: false,
      chatContainer: null,
      sessionId: "session_" + Math.random().toString(36).substr(2, 9),

      voltageStats: null,
      currentStats: null,
      powerStats: null,

      voltage: 0,
      current: 0,
      power: 0,
      solarpower: 0,
      batterypower: 0,
      batteryenergy: 0,
      solarenergy: 0,
      batterydirection: "backward",
      griddirection: "backward",
      energy: 0,
      device: "00-00-00-00-00-00-00",
      balance: BigInt(0),
      address: "",
      agAddress: "",
      rawTransactions: [],
      transactionsWithBalance: [],
      currentPage: 1,
      itemsPerPage: 5,
      customer: null,
      energyTokens: 0,

      product1: "./img/card-2.jpg",
      product2: "./img/card-3.jpg",
      product3: "./img/card-1.jpg",
      seq2: 0,
      chartDataFinancial: {
        labels: [],
        datasets: [],
      },


      chartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
          },
        },
        plugins: {
          legend: {
            display: true,
          },
        },
      },
    };
  },
};
